import { useEffect, useState } from 'react';
export function useLoaded(_ref) {
  var {
    crossOrigin,
    referrerPolicy,
    src,
    srcSet
  } = _ref;
  var [loaded, setLoaded] = useState(false);
  useEffect(() => {
    if (!src && !srcSet) {
      return undefined;
    }

    setLoaded(false);
    var active = true;
    var image = new Image();

    image.onload = () => {
      if (!active) {
        return;
      }

      setLoaded('loaded');
    };

    image.onerror = () => {
      if (!active) {
        return;
      }

      setLoaded('error');
    };

    image.crossOrigin = crossOrigin || null;
    image.referrerPolicy = referrerPolicy || '';
    image.src = src || '';

    if (srcSet) {
      image.srcset = srcSet;
    }

    return () => {
      active = false;
    };
  }, [crossOrigin, referrerPolicy, src, srcSet]);
  return loaded;
}
//# sourceMappingURL=useAvatar.js.map